import { render, staticRenderFns } from "./TimetableEvent.vue?vue&type=template&id=15bf82eb&scoped=true"
import script from "./TimetableEvent.vue?vue&type=script&lang=js"
export * from "./TimetableEvent.vue?vue&type=script&lang=js"
import style0 from "./TimetableEvent.vue?vue&type=style&index=0&id=15bf82eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bf82eb",
  null
  
)

export default component.exports